/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/* eslint-disable import/prefer-default-export */

import {
    endPlay,
    allowFlipPage,
    forbidFlipPage,
    nextPageWithoutFragment,
    prevPageWithoutFragment,
    showDialog,
    hideDialog,
    turnOnLaser,
    turnOffLaser,
    turnAnnotation,
    syncWithMaster,
    jumpPageRemote,
    beAudience,
} from '@src/framework/player/src/actions/control';
import store from '@player/src/store';
import { PlayerAction, RoomAction } from '@src/page/toc/common/meeting-room-manager/message_const';
import { laserBoardEventBus, annoationEventBus, laserBoardEventsKeys, annoationEventsKeys } from './event-bus-instance';
import { waitForSlideModelReady } from './waitForSlideModelReady';
import MeetingEventBus from '@src/page/toc/common/meeting-room-manager/components/eventBus';

export class PlayerHelper {
    static instance: PlayerHelper;
    static getInstance(): PlayerHelper {
        if (!PlayerHelper.instance) {
            PlayerHelper.instance = new PlayerHelper();
        }
        return PlayerHelper.instance;
    }

    public roomState = {
        currentPage: 0,
        currentFragment: 0,
        currentRev: 0,
        iaFragmentInfo: {},
        shouldStopMainAnim: false,
        isLoadPageBySwitchForward: false,
    };

    private remoteChangeLock = true;
    private stagedRemoteChangePage: any;

    constructor() {
        MeetingEventBus.onRecvRoomEvent(RoomAction.RemoteChangePage, data => this.onRemoteChangePage(data));
        MeetingEventBus.onRecvRoomEvent(RoomAction.LaserTrunOn, () => this.laserTurnOnAction(true));
        MeetingEventBus.onRecvRoomEvent(RoomAction.RemoteAllowFlipOn, () => store.dispatch(allowFlipPage()));
        MeetingEventBus.onRecvRoomEvent(RoomAction.RemoteAllowFlipOff, () => store.dispatch(forbidFlipPage()));
        MeetingEventBus.onRecvRoomEvent(RoomAction.BeAudience, () => store.dispatch(beAudience()));
        MeetingEventBus.onRecvRoomEvent(RoomAction.PrevPage, () => store.dispatch(prevPageWithoutFragment()));
        MeetingEventBus.onRecvRoomEvent(RoomAction.NextPage, () => store.dispatch(nextPageWithoutFragment()));
        MeetingEventBus.onRecvRoomEvent(RoomAction.ExitShow, () => store.dispatch(endPlay()));
        MeetingEventBus.onRecvRoomEvent(RoomAction.SyncWithMaster, () => store.dispatch(syncWithMaster()));
        MeetingEventBus.onRecvRoomEvent(RoomAction.PopWindowShow, () => store.dispatch(showDialog()));
        MeetingEventBus.onRecvRoomEvent(RoomAction.PopWindowHide, () => store.dispatch(hideDialog()));
        MeetingEventBus.onRecvRoomEvent(RoomAction.TurnLaser, () => this.onLaserTurn());
        MeetingEventBus.onRecvRoomEvent(RoomAction.TurnAnnotation, payload => store.dispatch(turnAnnotation(payload)));

        laserBoardEventBus.on(laserBoardEventsKeys.CUSOR_MOVE, (position) => {
            MeetingEventBus.sendPlayerEvent2Room(PlayerAction.PlayerMouseMove, position);
        });

        annoationEventBus.on(annoationEventsKeys.SPEAKER_BOARD_MESSAGE, (e) => {
            MeetingEventBus.sendPlayerEvent2Room(PlayerAction.AnnotationMessage, e);
        });

        waitForSlideModelReady.then(() => {
            this.remoteChangeLock = false;
            if (this.stagedRemoteChangePage) {
                this.onRemoteChangePage(this.stagedRemoteChangePage);
            }
        });
    }

    private onRemoteChangePage = (data) => {
        if (this.remoteChangeLock) {
            this.stagedRemoteChangePage = data;
            return;
        }

        this.roomState.currentPage = data.currentPage;
        this.roomState.currentFragment = data.currentFragment;
        this.roomState.iaFragmentInfo = data.iaFragmentInfo;
        this.roomState.shouldStopMainAnim = data.shouldStopMainAnim;
        this.roomState.isLoadPageBySwitchForward = data.isLoadPageBySwitchForward;
        const target = {
            p: data.currentPage,
            f: data.currentFragment,
            iaF: data.iaFragmentInfo,
            stopA: data.shouldStopMainAnim,
            prev: data.isLoadPageBySwitchForward,
            stopT: data.shouldStopTransition,
        };
        store.dispatch(jumpPageRemote(target));
    };

    private onLaserTurn() {
        const playControlState: any = store.getState().control || {};
        if (playControlState.laserTurnOn) {
            this.laserTurnOnAction(false);
        } else {
            this.laserTurnOnAction(true);
        }
    }

    private laserTurnOnAction(laserTurnOn) {
        if (laserTurnOn) {
            store.dispatch(turnOnLaser());
        } else {
            store.dispatch(turnOffLaser());
        }
    }
}
